"use client";

import { Box } from "../Box/Box";
import { CartLink } from "../CartLink/CartLink";

export function DesktopCheckoutButton(props: {
  itemCount: number;
  onGoToCheckout: () => void;
}) {
  return (
    <Box
      display={"flex"}
      style={{
        alignSelf: "stretch",
      }}
    >
      <CartLink
        cartItemQuantity={props.itemCount}
        onGoToCheckout={props.onGoToCheckout}
      />
    </Box>
  );
}
